import React from 'react';
import { css } from '@emotion/css';
import { Button, List } from 'antd';
import { Link, withRouter } from 'react-router-dom';

const suggestionsContainer = css`
	display: block;
	width: 100%;
	background-color: #fff;
	z-index: 3;
	position: absolute;
	top: 40px;
	overflow: hidden;
	overflow-y: scroll;
	margin-top: 20px;
	box-shadow: 0 0px 5px rgba(0, 0, 0, 0.3);
	border: 0;
	border-radius: 5px;
	a {
		color: #8c8c8c;
	}

	@media (max-width: 425px) {
		max-height: 180px;
	}
`;

const listItem = css`
	overflow: hidden;
	padding: 0 10px;
	margin: 0 !important;
`;

const listContainer = css`
	&:hover,
	&:focus,
	&:active {
		background-color: #e8e8e8;
	}

	.ant-list-item-content-single {
		margin: 0 !important;
	}
	.ant-list-item-meta-content {
		width: 80% !important;
		overflow: hidden;
	}
`;

const buttonStyle = css`
	border-radius: 0 0 4px 4px !important;
	background-color: #174ff4 !important;
	border: 0 !important;
	position: sticky !important;
	bottom: 0 !important;
`;

// Use to generate Highlighted Suggestion
const getBackgroundColor = (highlightedIndex, index) => {
	if (highlightedIndex === index) {
		return '#f5f5f5';
	}
	return 'inherit';
};

/*
	This component is use to display the suggestions of DataSearch component.
	We are using List component to generate list of suggestions.

	onValueSelected will receive the value defined at L97.

	A user can directly click a list item to go to Book Detail page and to see
	all results for a Query, click the button defined at L126. This button can
	be removed by passing prop hideShowButton={true}.

*/

const Suggestions = ({
	currentValue,
	getItemProps,
	data,
	rawData,
	highlightedIndex,
	hideShowButton,
	loading,
}) => {
	return (
		<div
			className={suggestionsContainer}
			style={{ maxHeight: window.location.pathname === '/' ? '285px' : ' 375px' }}
		>
			{
				<List
					itemLayout="vertical"
					dataSource={rawData && rawData.hits.hits.slice(0, 4)}
					loading={loading && (!rawData || (rawData && rawData.hits.hits.length === 0))}
					renderItem={(item, index) => {
						return (
							<List.Item
								className={listContainer}
								{...getItemProps({
									item: {
										value: item._source.original_title,
										source: item._source,
									},
								})}
								style={{
									backgroundColor: getBackgroundColor(highlightedIndex, index),
								}}
							>
								<Link to={`/book/${item._id}`}>
									<List.Item.Meta
										avatar={
											window.screen.availWidth > 425 ? (
												<img
													width={40}
													alt={item._source.original_title}
													src={item._source.image}
												/>
											) : null
										}
										className={listItem}
										title={item._source.original_title}
										description={item._source.authors.join(', ')}
									/>
								</Link>
							</List.Item>
						);
					}}
				/>
			}
			{data.length > 0 && !hideShowButton && (
				<Button
					block
					type="primary"
					className={buttonStyle}
					onClick={() => {
						window.location.href = `/search/?Search="${currentValue}"`;
					}}
				>
					{`Show all results for ${currentValue}`}
				</Button>
			)}
		</div>
	);
};

export default withRouter(Suggestions);
